import { memo } from 'react';

import { type ListSlackIntegrationsObject } from '@air/api/types';
import { RadioGroup, RadioGroupItem } from '@air/primitive-radio-group';

import { type UpdateBoardSlackIntegrationProps } from '~/swr-hooks/slack/useUpdateBoardSlackIntegration';

type ConnectedToSlackTogglesProps = {
  integration: ListSlackIntegrationsObject;
  boardId: string;
  onUpdate: (params: UpdateBoardSlackIntegrationProps) => void;
  canManageSlackIntegration?: boolean;
};

const options = [
  {
    id: 'this-board',
    label: 'This board only',
  },
  {
    id: 'with-descendants',
    label: 'This board and all sub-boards',
  },
];

export const ConnectedToSlackToggles = memo(
  ({ canManageSlackIntegration, integration, boardId, onUpdate }: ConnectedToSlackTogglesProps) => {
    return (
      <div className="mt-2 rounded-6 border border-grey-5 bg-grey-3 px-4 py-3">
        <div className="font-medium text-12 text-grey-12">Send notifications for:</div>
        <RadioGroup
          className="mt-2 gap-2"
          value={integration.includeDescendants ? 'with-descendants' : 'this-board'}
          disabled={!canManageSlackIntegration || integration.isCoveredByAncestor}
          onValueChange={(value) =>
            onUpdate({
              receiverId: integration.receiverId,
              boardId,
              includeDescendants: value === 'with-descendants',
              integrationId: integration.integrationId,
              channelName: integration.channelName,
            })
          }
        >
          {options.map(({ id, label }) => (
            <RadioGroupItem key={id} id={id} value={id} className="text-14 text-grey-12 [&>label]:w-full">
              {label}
            </RadioGroupItem>
          ))}
        </RadioGroup>
      </div>
    );
  },
);

ConnectedToSlackToggles.displayName = 'ConnectedToSlackToggles';
